<!--Error page starts-->
<section id="error">
    <div class="container-fluid forgot-password-bg">
        <div class="row full-height-vh">
            <div class="col-12 d-flex align-items-center justify-content-center">
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <img src="../../assets/img/gallery/error.png" alt="" class="img-fluid error-img mt-2"
                            height="300" width="400">
                        <h1 class="text-white mt-4">404 - Page Not Found!</h1>
                        <div class="error-text mx-auto mt-4">
                            <h5 class="text-white" *ngIf="_error_404_route_url">
                                <i class="loadingdots">no route for
                                    {{_error_404_route_url}}<span>.</span><span>.</span><span>.</span></i>
                            </h5>
                        </div>
                        <button (click)="Reconnect();" class="btn btn-primary btn-lg mt-3"><a 
                                class="text-decoration-none text-white">Go Back</a></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Error page ends-->